import ReactModal from 'react-modal';
import { Container, Head, Content } from './modal.styles.tsx';
import P from '../texts/p/P.tsx';
import Button from '../button/Button.tsx';
import Card from '../card/Card.tsx';
import Icon from '../icon/Icon.tsx';
import Spinner from '../Spinner/spinner.tsx';

const Modal = ({
  children,
  onSecondaryAction,
  secondaryVariant,
  secondaryText = '',
  onClose,
  isOpen,
  title,
  primaryVariant,
  onPrimaryAction,
  primaryActionDisabled = false,
  secondaryActionDisabled = false,
  primaryText,
  loadingPrimaryBtn = false,
  showOverlay = true,
  width = '448px',
  overflow = 'auto',
  tertiaryText,
  tertiaryVariant = 'tertiary-filled',
  onTertiaryAction,
  tertiaryActionDisabled = false,
}) => {
  const hasTertiaryAction = Boolean(tertiaryText && onTertiaryAction);

  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onClose}
      style={{
        overlay: {
          background: showOverlay ? 'rgba(0,0,0,0.65)' : 'transparent',
          zIndex: 1000,
        },
        content: {
          alignSelf: 'center',
          borderRadius: '16px',
          width: width,
          height: 'auto',
          maxHeight: '90vh',
          margin: '0 auto',
          padding: '0',
          overflow: overflow,
          zIndex: 1001,
        },
      }}
      shouldFocusAfterRender={false}
      ariaHideApp={false}
    >
      <Container>
        <Content>
          <Head>
            <P type='3' variant='neutral' weight='bold' withMargin={false}>
              {title}
            </P>
            {onSecondaryAction && (
              <Icon
                name='cancel_outline'
                cursor='pointer'
                onClick={onClose}
                variant='neutral'
              />
            )}
          </Head>
          {children}
          <Card
            gap='16px'
            display='flex'
            margin={{ top: '4' }}
            justifyContent={hasTertiaryAction ? 'space-between' : 'flex-end'}
            alignItems='center'
            minHeight='40px'
          >
            {hasTertiaryAction && secondaryText && (
              <Button variant={secondaryVariant} onClick={onSecondaryAction}>
                {secondaryText}
              </Button>
            )}
            <Card display='flex' gap='16px' justifyContent='flex-end'>
              {hasTertiaryAction && (
                <Button
                  variant={tertiaryVariant}
                  onClick={onTertiaryAction}
                  disabled={tertiaryActionDisabled}
                >
                  {tertiaryText}
                </Button>
              )}
              {!hasTertiaryAction && secondaryText && (
                <Button
                  variant={secondaryVariant}
                  onClick={onSecondaryAction}
                  disabled={secondaryActionDisabled}
                >
                  {secondaryText}
                </Button>
              )}
              <Button
                variant={primaryVariant}
                onClick={onPrimaryAction}
                disabled={primaryActionDisabled}
              >
                {loadingPrimaryBtn ? (
                  <Spinner size='sm' variant='primary' />
                ) : (
                  primaryText
                )}
              </Button>
            </Card>
          </Card>
        </Content>
      </Container>
    </ReactModal>
  );
};

export default Modal;
